import $ from 'jquery';
import 'magnific-popup/dist/jquery.magnific-popup';

/**
 * QuestionnaireV2 widget configs
 */
const questionnaireV2Semantics = {
    'mainWrapClass': 'questionnaire-v2',
    'instanceIdAttribute': 'data-instance-id',
    'isInitializedAttribute': 'data-is-initialized',
    'actionElement': '.questionnaire-v2__btn',
};

/**
 * QuestionnaireV2 initializer
 */
$(function () {
    QuestionnaireV2.init();
});

class QuestionnaireV2 {
    constructor() {
        this.pluginInstances = {};
    }

    static init() {
        if ($(`.${questionnaireV2Semantics.mainWrapClass}`).length === 0) {
            return false;
        }

        if (!window || !window.widgets || !window.widgets.questionnaireV2) {
            window.widgets.questionnaireV2 = new QuestionnaireV2();
        }

        /**
         * Checking other instances
         */
        $(`.${questionnaireV2Semantics.mainWrapClass}`).each((index, el) => {
            let isInitialized =
                ($(el).attr(`${questionnaireV2Semantics.isInitializedAttribute}`) === 'true');
            if (!isInitialized) {
                window.widgets.questionnaireV2.registerInstance($(el));
                window.widgets.questionnaireV2.registerPopup($(el));
            }
        });
    }

    /**
     * Register instance
     * @param JQuery element
     * @throws
     */
    registerInstance(el) {
        let instanceId =
            el.attr(`${questionnaireV2Semantics.instanceIdAttribute}`) || false;

        if (instanceId === false) {
            throw new Error(`Invalid jQuery selector for ` +
                `instance slider with id [${instanceId}]`);
        }

        try {
            // TODO[dependDetected]: slick plugin
            let object = el.find(`.${questionnaireV2Semantics.mainWrapClass}`);
            el.attr(`${questionnaireV2Semantics.isInitializedAttribute}`, true);
            this.pluginInstances[instanceId] = object;
        } catch (e) {
            el.hide();
            throw e;
        }
    }

    registerPopup(el) {
        let actionBtn = el.find(questionnaireV2Semantics.actionElement);
         actionBtn.magnificPopup({
            items: {
                src: actionBtn.attr('data-popup'),
                type: 'inline'
            },
            midClick: true,
            showCloseBtn: false
        });
    }

    reInit(instanceId) {
        QuestionnaireV2.init();
    }
}